import { useEffect, useState, type FC } from 'react';
import { useSelector } from 'react-redux';

import { selectListId } from '@core/reducers/eventingSlice';
import { selectInput } from '@core/reducers/inputsSlice';
import type { Hit } from '@core/ts/algolia';
import type { VoyagerResult } from '@core/ts/results';

import sortHits from '../../utils/sortHits';
import DefaultExactMatches from './DefaultExactMatches';

type Props = {
  results: VoyagerResult[];
  uniqueMatches: VoyagerResult[];
  ExactMatchesComponent: FC<any>;
};

const ExactMatches: FC<Props> = ({ results = [], uniqueMatches, ExactMatchesComponent = DefaultExactMatches }) => {
  // Redux store dispatch function hook

  // Store properties
  const listId = useSelector(selectListId);

  const [_hits, setHits] = useState<Hit[]>([]);
  const zip = useSelector((state) => selectInput(state, 'zip'));

  useEffect(() => {
    sortHits(results as Hit[], zip).then((sortedHits) => setHits(sortedHits));
  }, [results, zip]);

  return (
    <ExactMatchesComponent
      borrowedMatches={uniqueMatches}
      listId={listId}
      exactMatches={_hits}
      sideBarDisplayed={false}
    />
  );
};

export default ExactMatches;
